import t from 'tcomb';

const OktaConfig = t.struct({
    clientId: t.String,
    issuer: t.String,
    redirectUri: t.String
}, {
    name: 'OktaConfig',
    strict: true
});

export const getDefaultState = () => new OktaConfig({
    clientId: '',
    issuer: '',
    redirectUri: ''
});

export default OktaConfig;



// WEBPACK FOOTER //
// ./src/shared/models/okta-config.js